import { render } from "./TvmNavigateToInventory.vue?vue&type=template&id=39ad926c&scoped=true"
import script from "./TvmNavigateToInventory.js?vue&type=script&lang=js&external"
export * from "./TvmNavigateToInventory.js?vue&type=script&lang=js&external"

import "./TvmNavigateToInventory.vue?vue&type=style&index=0&id=39ad926c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ad926c"],['__file',"src/components/ChatWidget/TvmNavigateToInventory/TvmNavigateToInventory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39ad926c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39ad926c', __exports__)) {
    api.reload('39ad926c', __exports__)
  }
  
  module.hot.accept("./TvmNavigateToInventory.vue?vue&type=template&id=39ad926c&scoped=true", () => {
    api.rerender('39ad926c', render)
  })

}


export default __exports__